module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'pet-wrapper': _vm.showDetails
    }
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-responsive img-rounded",
    staticStyle: {
      "min-width": "60px",
      "min-height": "60px",
      "border": "1px solid #c3c3c3"
    },
    attrs: {
      "src": _vm.profilePhotoPathComp,
      "alt": "",
      "height": "80",
      "width": "80"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-left"
  }, [_c('h4', {
    staticClass: "media-heading main-name",
    staticStyle: {
      "padding-bottom": "0px",
      "margin-bottom": "3px"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.petComp.Name))])]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted",
    staticStyle: {
      "padding-top": "0px",
      "margin-top": "0px",
      "padding-bottom": "0px",
      "margin-bottom": "3px"
    }
  }, [_vm._v(" " + _vm._s(_vm.ageToString(_vm.petComp)))]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "padding-top": "0px",
      "margin-top": "0px",
      "padding-bottom": "0px",
      "margin-bottom": "0px"
    }
  }, [_vm._v(_vm._s(_vm.genderToString(_vm.petComp.Gender)) + " " + _vm._s(_vm.petTypeToString(_vm.petComp.PetType)))])])]), _vm._v(" "), _c('div', {
    staticClass: "media-right media-bottom"
  }, [(_vm.showDetails) ? _c('button', {
    staticClass: "btn btn-default ",
    on: {
      "click": function($event) {
        _vm.viewPet()
      }
    }
  }, [_vm._v("View Profile")]) : _vm._e(), _vm._v(" "), (_vm.viewPetModal) ? _c('PetDetailsView', {
    attrs: {
      "petId": _vm.petId
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec549d4e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SharedComponents/PetSelectCard.vue
// module id = 662
// module chunks = 2